import React, { useState, useRef, useContext} from "react";

import {View,  Text, TextInput, TouchableOpacity, BackHandler, Image}  from 'react-native';

import {useNavigation} from '@react-navigation/native'

import cores from '../util/cores'

import {estilos} from '../util/estilos'

import RotuloErro from '../componentes/RotuloErro'

import * as util from '../util/util'

import * as texto from '../util/texto'

import {login, recuperar_senha, usuario_gestor, usuario_admin, buscar_usuario_login_google} from '../ws/ws_usuarios'

import Botao from '../componentes/Botao'

import {ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import { useFocusEffect } from '@react-navigation/native';

import {AMBIENTE, GOOGLE_CLIENT_ID} from '../util/params'

import {TIPO_AMB_DEV, TELA_NOVO_USUARIO, 
    TIPO_LOGIN_NORMAL, TIPO_LOGIN_GOOGLE,
    TELA_PRINCIPAL,PRIVILEGIO_NENHUM, PRIVILEGIO_GESTOR, PRIVILEGIO_ADMIN, } from '../util/constantes'

import Bloco from '../componentes/Bloco'

import dimens from '../util/dimens'

import contexto from '../util/contexto'

import ver_senha from '../imgs/ver_senha.png'

import ocultar_senha from '../imgs/ocultar_senha.png'

import Alerta from '../componentes/Alerta'

import {saldoAtual as wsSaldoAtual} from '../ws/ws_saldo'

import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';




export default function TelaLogin(){
   
    const {setValorContexto} = useContext(contexto);

    const [nome, setNome] = useState(null)
    const [senha, setSenha] = useState(null)
    const [msgErro, setMsgErro] = useState(null)

    const [mostrarSenha, setMostrarSenha] = useState(true);
	
    const navegacao = new useNavigation();

    const entrarRef  = useRef(null)
    
    const [recuperarSenha, setRecuperarSenha] = useState(false);
    const [emailRecuperaSenha, setEmailRecuperaSenha] = useState(null);

    const btRecuperarSenhaRef  = useRef(null)
    
    const blockBackRef = useRef(false);



    const voltar = () => {
                
        if(blockBackRef.current == true){
                        
            setMsgErro(null);
                
            setRecuperarSenha(false);
            
            blockBackRef.current = false;
        }
         
        return true;
    };

   
    useFocusEffect(React.useCallback(() => {
		
		util.print("TelaLogin");
		
		if(AMBIENTE == TIPO_AMB_DEV){
			
			setNome("99214334234")
			setSenha("12345678")
		}	
		
        BackHandler.addEventListener('hardwareBackPress', voltar);
        
        return () => {
            BackHandler.removeEventListener('hardwareBackPress', voltar);
        };

	}, []));



    async function entrar(){
		
        util.print("login convencional");

        entrarRef.current.setCarregando(true)
        
        setMsgErro(null);

        if(texto.isBlanck(nome)){

            loginErro("Informe seu CPF ou E-mail.");
            return;
        } 

        if(texto.isBlanck(senha)){

            loginErro("Informe a senha.");
            return;
        } 

		let token = await util.getToken();
		
        let usuario  = await login(TIPO_LOGIN_NORMAL, nome, senha, token);

        if(usuario === null){
                
            loginErro("CPF/E-mail ou senha inválidos.");
             return;
        }

        loginSucesso(usuario);
    }


    const loginErro=(mensagem)=>{
		
        entrarRef.current.setCarregando(false);
     
        setMsgErro(mensagem);
    }


    const loginSucesso= async (usuario)=>{
		
        setValorContexto(prevState =>({...prevState, idUsuarioAtual: usuario.id}));

        setValorContexto(prevState =>({...prevState, nomeUsuarioAtual: usuario.nome_completo}));

        let retorno = await usuario_admin(usuario.id);
		
        let privilegio = null;

		if(retorno!=null && retorno.admin>0)
			privilegio = PRIVILEGIO_ADMIN;	
		else{	
				
			retorno = await usuario_gestor(usuario.id);

			if(retorno!=null && retorno.gestor>0)
				privilegio = PRIVILEGIO_GESTOR;
			else
                privilegio = PRIVILEGIO_NENHUM;
		}

        setValorContexto(prevState =>({...prevState, privilegio: privilegio}));

        let saldo  = await wsSaldoAtual(usuario.id);
		
        setValorContexto(prevState =>({...prevState, saldoAtual: saldo!=null?saldo.saldo:0}));

        entrarRef.current.setCarregando(false)

        setMsgErro(null);

		navegacao.replace(TELA_PRINCIPAL)
    }

  
	const criarNovoUsuario= async ()=>{
		
		navegacao.replace(TELA_NOVO_USUARIO)
    }
	

    const acaoRecuperarSenha= async ()=>{

        util.print("acaoRecuperarSenha");

        btRecuperarSenhaRef.current.setCarregando(true)
        
        setMsgErro(null);

        if(texto.isBlanck(emailRecuperaSenha)){

            btRecuperarSenhaRef.current.setCarregando(false);
     
            setMsgErro("Informe o e-mail de recuperação.");
            return;
        } 

        let retorno = await recuperar_senha(emailRecuperaSenha);

        if(retorno === null || retorno.token==null){
                
            btRecuperarSenhaRef.current.setCarregando(false);
     
            setMsgErro(retorno.mensagem);
            return;
        }

        Alerta("Sucesso", 'Um e-mail foi enviado para '+emailRecuperaSenha+' com as instruções para a recuperação de sua senha.');

        btRecuperarSenhaRef.current.setCarregando(false)
        
        blockBackRef.current = false;

        setRecuperarSenha(false)
    }


    const loginGoogle = async (response) => {
        
        util.print("login Google");

        if(response!=null && response.credential !=null){

            let dados = await buscar_usuario_login_google(response.credential);

            if(dados!=null){

                let usuario  = await login(TIPO_LOGIN_GOOGLE, null, null, null, dados.email, dados.name, null, dados.picture);

                if(usuario !== null){
                    loginSucesso(usuario);
                    return;
                }
            }
        }
           
        loginGoogleErro();
    };


    const loginGoogleErro = (error) => {
        Alerta("Atenção", "Um erro ocorreu ao recuperar as informações do usuário.");
    };


    return (
       
		<ViewDegradeVertical titulo="Login" voltar={()=>voltar()} ocultarPontos={true}> 
			{recuperarSenha?
                <Bloco todaArea={true}>    
                    <View style={{marginTop:25}}/>
                        
                    <View style={{alignItems:'center'}}>    
                        <View style={{marginTop:25}}/>
                        <Text style={estilos.rotulo_titulo}>Recuperar Senha</Text>
                        <View style={{marginTop:35}}/>
                    </View>   
                        <Text style={estilos.rotulo_padrao}>Informe o e-mail cadastrado:</Text>
                        <TextInput
                            placeholder=""
                            style={estilos.campo_padrao} 
                            multiline={false}
                            onChangeText={(text)=>setEmailRecuperaSenha(text)}
                            maxLength={150}
                            value={emailRecuperaSenha}/>
                    
                    <View style={{alignItems:'center'}}>     
                        
                        <View style={{marginTop:35}}/>
                        
                        {util.temConteudo(msgErro) && 
                            <RotuloErro mensagem={msgErro}/>
                        }
                        <View style={{marginTop:10}}/>

                        <Botao 
                            acao={()=>acaoRecuperarSenha()}
                            texto="Enviar"
                            ref={btRecuperarSenhaRef}/>   
                        
                        <View style={{marginTop:10}}/>
                    </View> 
                </Bloco>:   
                
                <Bloco todaArea={true}>                   
                    
                        <View style={{marginTop:25}}/>
                        
                        <View style={{alignItems:'center'}}>    
                             
                        </View>

                        <View style={{marginTop:25}}/>

                        <View style={estilos.separador}/>

                        <View style={{marginTop:25}}/>

                        <Text style={estilos.rotulo_padrao}>E-mail ou CPF:</Text>
                                            
                        <TextInput  
                            placeholder="" 
                            style={estilos.campo_padrao} 
                            onChangeText={(text)=>setNome(text)}
                            maxLength={150}
                            value={nome}/>	

                        <View style={{marginTop:10}}/>   

                        <Text style={estilos.rotulo_padrao}>Senha:</Text>

                        <View style={estilos.grade}>
                            <View style={estilos.coluna}>                  
                                <TextInput
                                    placeholder="Digite sua senha..."
                                    style={estilos.campo_padrao} 
                                    secureTextEntry={mostrarSenha}
                                    textContentType={'password'} 
                                    multiline={false}
                                    onChangeText={(text)=>setSenha(text)}
                                    maxLength={32}
                                    value={senha}/>
                            </View>
                            <TouchableOpacity onPress={()=>setMostrarSenha(!mostrarSenha)}>
                                <View style={{borderColor: cores.cinza_claro,borderWidth:1, marginLeft:2, borderRadius:4, padding:3}}>
									{mostrarSenha?
										<Image source={ver_senha} style={{width:30, height: 30}}/>:
										<Image source={ocultar_senha} style={{width:30, height: 30}}/>
									}
								</View>
                            </TouchableOpacity>
                        </View>   

                        <View style={{marginTop:20}}/>

                        {util.temConteudo(msgErro) && 
                            <View style={{alignItems:'center'}}> 
                                <RotuloErro mensagem={msgErro}/>
                            </View>
                        }

                        <View style={{marginTop:5}}/>

                        <View style={estilos.grade}>
                            <View style={estilos.coluna}/> 
                            <View style={[estilos.coluna_dupla, {alignItems:'center'}]}>
                                <Botao 
                                    acao={()=>entrar()}
                                    texto="Acessar"
                                    ref={entrarRef}/>   
                            </View>
                            <View style={estilos.coluna}/> 
                        </View>
                        
                        <View style={{marginTop:25}}/> 
						<View style={{alignItems:'center'}}> 
                            <Text style={{color:cores.fonte_escura, fontSize:dimens.fonte_rotulo, marginTop:8, marginLeft:10, marginRight:10}}>Outras opções de login:</Text>   
                        </View>
                        <View style={{marginTop:25}}/> 
                        
                        <View style={{alignItems:'center'}}>    
                            <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                                <div>
                                    <GoogleLogin onSuccess={loginGoogle} onError={loginGoogleErro}/>
                                </div>
                            </GoogleOAuthProvider>
                        </View>

                        <View style={{marginTop:40}}/>
                        <View style={estilos.separador}/>
                        <View style={{marginTop:40}}/>

                        <View style={estilos.grade}>
                            <View style={[estilos.coluna_dupla, {alignItems:'center'}]}> 
                                <Text style={[estilos.rotulo_padrao, {marginTop:10}]}>Ainda não tem cadastro?</Text>
                            </View>
                            <View style={estilos.coluna}>
                                <Botao 
                                    acao={()=>criarNovoUsuario()}
                                    texto="Cadastrar"
                                    somente_texto={true}/>   
                            </View>
                        </View>
                        <View style={{marginTop:20}}/>

                        <View style={estilos.grade}>
                            <View style={[estilos.coluna_dupla, {alignItems:'center'}]}> 
                                <Text style={[estilos.rotulo_padrao, {marginTop:10}]}>Esqueceu sua senha?</Text>
                            </View>
                            <View style={estilos.coluna}>
                                <Botao 
                                    acao={()=>{
                                        
                                        setMsgErro(null);

                                        blockBackRef.current = true;

                                        setRecuperarSenha(true)

                                    }}
                                    texto="Recuperar"
                                    somente_texto={true}/>   
                            </View>
                        </View>
                        <View style={{marginTop:50}}/> 
                     
                </Bloco>   
            }  
        </ViewDegradeVertical>
    )
}
